export default function ($rootScope) {
    return {
        restrict: 'E',
        transclude: true,
        /* eslint-disable no-param-reassign */
        link: () => {

            const userEmailElement = document.querySelector('#userEmail');
            const observer = new MutationObserver(() => {
                $rootScope.$broadcast('ACCOUNT_CHANGE', {});
            });
            observer.observe(userEmailElement, {
                characterData: true,
                subtree: true,
                childList: true
            });
        }
    };
};